@if (field.addOnButtons == null) {
  <ng-container [ngTemplateOutlet]="child"></ng-container>
}
@if (field.addOnButtons != null) {
  <p-inputgroup>
    <ng-container [ngTemplateOutlet]="child"></ng-container>
    @for (addOn of field.addOnButtons; track addOn) {
      @if (addOn.isButton) {
        <button pButton [disabled]="!addOn.isEnabled(field)" [icon]="addOn.icon"  [pTooltip]="addOn.text" (click)="clickAddOn(addOn, $event)"></button>
      }
      @else {
        <span class="p-inputgroup-addon">
          <i [class]="addOn.icon" [pTooltip]="addOn.text"></i>
        </span>
      }
      
    }
  </p-inputgroup>
}
